import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import {
  LayoutBand,
  Grid,
  Bleed,
  Card,
  Cell,
  H2,
  H3,
  Image,
  Paragraph,
  Separator,
  useContainerWidth,
} from '@fs/zion-ui'
import familyHistoryImage from '../assets/FamilyHistoryInformation.webp'

const listCss = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
export default function BasicFamilyHistorySection(): JSX.Element {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()

  return (
    <LayoutBand maxWidth="xxl" marginY="xxl" marginX={atWidth({ default: 'sm', lg: 'xxl' })}>
      {/* Main section heading */}
      <H2>{t('tree-overview.family-interview.basic.heading', 'Basic Family History Information')}</H2>

      <Separator size="md" />

      {/* Intro paragraph */}
      <Paragraph size="sm">
        {t(
          'tree-overview.family-interview.basic.intro',
          'Gather as much of this information as possible about your parents, grandparents, and great-grandparents.'
        )}
      </Paragraph>

      <Separator size="lg" />

      {/* Two-column responsive grid */}
      <Grid gutters={atWidth({ default: 'sm', xl: 'xxl' })}>
        {/* Left column: Image */}
        <Card columns={atWidth({ default: 12, lg: 6 })} minHeight={400}>
          <Bleed all>
            <Image alt="" src={familyHistoryImage} positionX="left" />
          </Bleed>
        </Card>

        {/* Right column: Content */}
        <Cell alignY="middle" columns={atWidth({ default: 12, lg: 6 })} css={listCss}>
          <H3 size="H4">
            {t('tree-overview.family-interview.basic.list-heading', 'For Each Ancestor, Try to Gather')}
          </H3>

          <Separator size="sm" />

          <ul>
            <li>{t('tree-overview.family-interview.basic.item1', 'Full name (for women, include maiden name)')}</li>
            <li>{t('tree-overview.family-interview.basic.item2', 'Birth date (or approximate year)')}</li>
            <li>{t('tree-overview.family-interview.basic.item3', 'Birth place (city, province, or country)')}</li>
            <li>{t('tree-overview.family-interview.basic.item4', 'Death date (or approximate year)')}</li>
            <li>{t('tree-overview.family-interview.basic.item5', 'Death place (city, province, or country)')}</li>
            <li>{t('tree-overview.family-interview.basic.item6', 'Marriage date and place (optional)')}</li>
            <li>{t('tree-overview.family-interview.basic.item7', 'Names of siblings (optional)')}</li>
          </ul>
        </Cell>
      </Grid>
    </LayoutBand>
  )
}
